/** Shared `{ value, label }` enum entry shape served by the API, as it comes off the wire. */
export type AiModelFamilyPayload = {
	readonly value: string;
	readonly label: string;
};

export type AiModelFamiliesFetchedPayload = AiModelFamilyPayload[];

export type AiModelFamiliesFetchedAction = {
	type: 'AI_MODEL_FAMILIES_FETCHED';
	payload: AiModelFamiliesFetchedPayload;
};

export default (payload: AiModelFamiliesFetchedPayload): AiModelFamiliesFetchedAction => ({
	type: 'AI_MODEL_FAMILIES_FETCHED',
	payload,
});
